"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _typography = require("../tokens/typography");
var _color = require("../tokens/color");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable prettier/prettier */

// eslint-disable-next-line react/prop-types
var Mark = function Mark(props) {
  return /*#__PURE__*/_react["default"].createElement(Mark.Element, props, props.children);
};
Mark.Element = _styledComponents["default"].mark.withConfig({
  componentId: "sc-qeo8wm-0"
})(["line-height:", ";padding:0 0.2rem;margin-block-start:0.67em;margin-block-end:0.67em;margin-inline-start:0px;margin-inline-end:0px;font-weight:", ";", ""], _typography.lineHeight.regular, _typography.fontWeights.bold, function (props) {
  switch (props.type) {
    case "bg":
      return (0, _styledComponents.css)(["color:", ";background-color:", ";font-weight:", ";"], _color.grey.z900, _color.yellow.z200, _typography.fontWeights.medium);
    case "strikethrough":
      return (0, _styledComponents.css)(["color:", ";text-decoration-line:line-through;background-color:transparent;"], _color.grey.z800);
    default:
      return (0, _styledComponents.css)(["color:", ";background-color:transparent;font-weight:", ";"], _color.black, _typography.fontWeights.medium);
  }
});
Mark.propTypes = {
  type: _propTypes["default"].oneOf(["bg", "text", "strikethrough"])
};
Mark.defaultProps = {
  type: "text"
};
var _default = exports["default"] = Mark;